import { render, staticRenderFns } from "./LostPayment.vue?vue&type=template&id=15478cdb&scoped=true"
import script from "./LostPayment.vue?vue&type=script&lang=js"
export * from "./LostPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15478cdb",
  null
  
)

export default component.exports